export default {"src":"/_next/static/media/phone.2b65f081.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};